import React, { createContext, useContext, useState, ReactNode } from 'react';

interface WeightContextType {
  globalWeight: number;
  setGlobalWeight: (weight: number) => void;
  getWeightOptions: (defaultWeight: number) => number[];
}

const WeightContext = createContext<WeightContextType | undefined>(undefined);

interface WeightProviderProps {
  children: ReactNode;
}

export const WeightProvider: React.FC<WeightProviderProps> = ({ children }) => {
  const [globalWeight, setGlobalWeight] = useState<number>(1000); // Default to 1000g

  const getWeightOptions = (defaultWeight: number): number[] => {
    const standardOptions = [100, 250, 500, 1000, 1500, 2000];
    if (!standardOptions.includes(defaultWeight)) {
      standardOptions.push(defaultWeight);
      standardOptions.sort((a, b) => a - b);
    }
    return standardOptions;
  };

  return (
    <WeightContext.Provider value={{ globalWeight, setGlobalWeight, getWeightOptions }}>
      {children}
    </WeightContext.Provider>
  );
};

export const useWeight = (): WeightContextType => {
  const context = useContext(WeightContext);
  if (context === undefined) {
    throw new Error('useWeight must be used within a WeightProvider');
  }
  return context;
};
